<ion-header *ngIf="appointment">
	<ion-toolbar color="primary" mode="md">
		<ion-buttons slot="start">
			<ion-button (click)="openMenu()" auto-hide="false">
				<ion-icon name="menu-outline" size="large"></ion-icon>
			</ion-button>
		</ion-buttons>
		<ion-buttons slot="primary">
			<app-sync-button></app-sync-button>
			<!-- <ion-button (click)="openMenu('main-options')" auto-hide="false">
				<ion-icon
					slot="icon-only"
					ios="ellipsis-horizontal"
					md="ellipsis-vertical"
				></ion-icon>
			</ion-button> -->
		</ion-buttons>
		<ion-title>
			<div class="appointment-title">
				{{ appointment.displayValue }}
			</div>
		</ion-title>
	</ion-toolbar>
	<ion-toolbar>
		<ion-list lines="none">
			<ion-item>
				<ion-text class="page-title">{{ pageTitle }}</ion-text>
			</ion-item>
		</ion-list>
		<ion-buttons slot="primary">
			<app-change-status-button
				[ticketStatusId]="appointment.ticketStatusId"
				[ticketStatusDesc]="appointment.ticketStatusDesc"
				[apptId]="appointment.id"
				fill="solid"
			></app-change-status-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<!-- Menu -->
<ion-menu
	side="start"
	[menuId]="appointmentMenuId"
	contentId="appointment-tabs"
>
	<ion-header>
		<ion-toolbar>
			<ion-title>
				Menu
			</ion-title>
		</ion-toolbar>
	</ion-header>
	<ion-content>
		<ion-list lines="full">
			<ion-item
				*ngFor="let route of routes"
				button
				(click)="navigateTo(route)"
				[color]="route.text === pageTitle ? 'primary' : ''"
			>
				<ion-icon
					*ngIf="route.icon"
					slot="start"
					[name]="route.icon"
				></ion-icon>
				<ion-text>{{ route.text }}</ion-text>
			</ion-item>
		</ion-list>
	</ion-content>
</ion-menu>
